import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import './index.scss';
import { Tooltip } from 'antd';
import { InfoCircleFilled } from '@ant-design/icons';

const InputSelect = ({ className, placeholder, labelId, id, label, error, info, invalid, ...props }) => {
	return (
		<div className={className}>
			{label && (
				<label htmlFor={labelId} className='form-label d-flex'>
					{label}
					{info && (
						<Tooltip title={info}>
							<InfoCircleFilled className='mx-1' />
						</Tooltip>
					)}
				</label>
			)}
			<Select
				menuShouldScrollIntoView={false}
				placeholder={placeholder}
				styles={{
					container: (provided, state) => ({
						...provided,
						zIndex: state.isFocused ? 9999 : 1,
						border: error && error.message ? 'solid 1px #8F220E' : undefined,
						borderRadius: error && error.message ? '5px' : undefined
					})
				}}
				isDisabled={props.disabled}
				{...props}
			/>
			{error && error.message && (
				<div id={id} className='invalid-feedback d-block'>
					{error.message}
				</div>
			)}
		</div>
	);
};

InputSelect.propTypes = {
	className: PropTypes.string,
	placeholder: PropTypes.string,
	id: PropTypes.string,
	error: PropTypes.object,
	label: PropTypes.string,
	labelId: PropTypes.string
};

export default InputSelect;
